<div class="container">
	<nz-spin [nzSpinning]="isLoading()" nzTip="Loading rubric content levels...">
		@if (!isLoading()) {
			<nz-table #basicTable nzBordered nzSize="middle" [nzData]="contentLevels()" [nzNoResult]="noData">
				<thead>
					<tr>
						<th>Skill</th>
						<th>Available Levels</th>
					</tr>
				</thead>
				<tbody>
					@for (item of basicTable.data; track item) {
						<tr>
							<td>{{ item.skillCode | titlecase }}</td>
							<td>
								@for (level of item.levels; track level) {
									<nz-tag nzColor="blue">Level {{ level }}</nz-tag>
								}
								@if (item.levels.length === 0) {
									<span>No levels available</span>
								}
							</td>
						</tr>
					}
				</tbody>
			</nz-table>
		}

		<ng-template #noData>
			<nz-empty nzNotFoundContent="No rubric content levels found for this course and rubric."></nz-empty>
		</ng-template>
	</nz-spin>
</div>
